import React, { useContext, useState, useEffect, useCallback } from 'react';
import { svgSprite, Portal, Img } from '../../../../hybrid/wrappers';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import Cart from '../../../../widgets/cart/Cart/Cart';
import UserContext, { StoreContext } from '../../../../common/utils/getContext';
import CartFooter from '../../../../widgets/cart/CartFooter/CartFooter';
import { navigateV2 } from '../../../../common/utils/router';
import T from '../../../../common/components/T';
import uikit from '../../../../project/uikit/styles';
import css from './cart-buttons.module.scss';
import classNames from 'classnames';
import Plug from '../../../../widgets/plug/Plug/Plug';
import shop_cart_is_empty from '../../../../public/src/img/plugs/shop_cart_is_empty.svg';
import wish_list_empty from '../../../../public/src/img/plugs/wish_list_empty.svg';
import ArrowLeftLong from '../../../../public/src/img/arrow-left-long.svg';
import Display from '../../../../common/components/Display';

const WishesInfo = ({ setShowWishesInfo }) => (
    <div
        className={classNames(css.cartWidget, css.wishlistInfoWidget)}
        onMouseLeave={() => {
            setShowWishesInfo(false);
        }}
    >
        <div className={css.cartTriangle}>
            {svgSprite('arrow-dropdown-up', { fill: 'var(--whiteColor)', width: '33px', height: '15px' })}
        </div>
        <Plug
            classes={{
                plugImg: [css.wishListPlugImg]
                // plugContainer: [css.emptyCart, css.wrapCartContent]
            }}
            plugImg={wish_list_empty}
            plugTitle={<T textName='store-WishList-isEmpty' defaultStr='Список желаний пуст' page='/store' />}
            plugDescription={
                <T
                    textName='store-WishList-isEmptyDescriptioon'
                    defaultStr='Добавляйте товары в «Список желаний», чтобы не потерять'
                    page='/store'
                />
            }
            btnGroups={[
                [
                    {
                        style: {
                            fontSize: '1rem',
                            minHeight: '48px',
                            paddingBottom: 0,
                            paddingTop: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        },
                        text: <T textName='store-Basket-GoToBuying' defaultStr='Перейти к покупкам' page='/store' />,
                        onClick: () => {
                            setTimeout(() => setShowWishesInfo(false), 400);
                            navigateV2('/store');
                        }
                    }
                ]
            ]}
        />
        <div className={css.cartWidgetClose} onClick={() => setShowWishesInfo(false)}>
            {svgSprite('cross', {
                width: '10px',
                height: '10px',
                fill: 'var(--greyExtraDarkColor)'
            })}
        </div>
    </div>
);
const Cartbuttons = ({ openCart, setOpenCart }) => {
    const { lang } = useContext(UserContext);
    const { cartData, cart, setCart } = useContext(StoreContext);
    const products = cartData && cartData?.items ? cartData?.items : [];
    const price = cartData?.total_price_formatted;
    // const price_marketing = cartData?.total_marketing_price_formatted;
    // const [showCartWidget, setShowCartWidget] = useState(false);
    const [showWishesInfo, setShowWishesInfo] = useState(false);

    const widthDimensions = useWindowDimensions();
    // const [mobile, setMobile] = useState('');
    const modalWishlist = widthDimensions < 768;
    // useEffect(() => {
    //     widthDimensions < 768 ? setMobile(true) : setMobile(false);
    // }, [widthDimensions]);
    const closeModal = useCallback(() => {
        setOpenCart(false);
        setCart(!cart);
    }, [cart, setCart, setOpenCart]);

    const cartHandler = useCallback(() => {
        setCart(!cart);
    }, [setCart, cart]);

    // const wishesHandler = useCallback(() => {
    //     if (!userToken) {
    //         setShowRegWindow({ redirect: '/store/wishlist' });
    //     } else if (!wishlist.data?.length) {
    //         setShowWishesInfo(true);
    //     } else {
    //         navigateV2('/store/wishlist');
    //     }
    // }, [setShowRegWindow, userToken, wishlist.data?.length]);

    useEffect(() => {
        if (openCart) {
            cartHandler();
        }
    }, [openCart, cartHandler]);

    return (
        <div className={css.cartWidgetWrap}>
            {/* <div className={classNames(css.cartIcon, css.wishIcon)} onClick={wishesHandler}>
                {svgSprite('heart', {
                    className: classNames(css.cartIconSvg, css.wishIconSvg)
                })}
                {wishlist?.meta?.count > 0 && <div className={css.cartIconItem}>{wishlist?.meta?.count}</div>}
            </div> */}
            <div className={css.cartIcon}>
                {svgSprite('cart-new', { className: css.cartIconSvg })}
                {products && (
                    <div className={classNames(css.cartIconItem, { [css.cartIconItemEmpty]: products?.length === 0 })}>
                        {products.reduce((accumulator, currentValue) => accumulator + currentValue.quantity, 0)}
                    </div>
                )}
            </div>
            <div className={css.cartPrice}>
                <p className={css.cartPriceTop}>{price ? price : <Display type={'value'} data={{ value: 0 }} />}</p>
            </div>
            {showWishesInfo ? (
                !modalWishlist ? (
                    <>
                        <WishesInfo setShowWishesInfo={setShowWishesInfo} />
                        <div className={css.cartWidgetBackground} onClick={() => setShowWishesInfo(false)}></div>
                    </>
                ) : (
                    <Portal closeHandler={() => setShowWishesInfo(false)}>
                        <WishesInfo setShowWishesInfo={setShowWishesInfo} />
                    </Portal>
                )
            ) : null}
            {/* {!mobile && showCartWidget && products && products.length > 0 && (
                <>
                    <div className={classNames(css.cartWidget)} onMouseLeave={() => setShowCartWidget(false)}>
                        <div className={css.cartTriangle}>
                            {svgSprite('arrow-dropdown-up', {
                                fill: 'var(--whiteColor)',
                                width: '33px',
                                height: '15px'
                            })}
                        </div>
                        <Cart products={products} type='hover-widget' price={price} price_marketing={price_marketing} />
                    </div>
                    <div className={css.cartWidgetBackground} onClick={() => setShowCartWidget(false)}></div>
                </>
            )} */}
            {cart && (
                <Portal closeHandler={closeModal} customClass={'modalTop'}>
                    <div
                        className={classNames('custom-scroll', css.adminFilterWindowWrapper, css.adminFilterWindowWrapperWebFull)}
                    >
                        {products.length > 0 ? (
                            <div onClick={(e) => e.stopPropagation()} className={css.adminWindowContentWrapper}>
                                <div className={css.cartHeaderTitle}>
                                    <div onClick={closeModal} className={css.wrapArrowBack}>
                                        <Img src={ArrowLeftLong} width={24} height={24} />
                                    </div>
                                    <div className={css.titleBlock}>
                                        <T textName='BasketPageTitle' defaultStr='Корзина' page='/store' />
                                        <div className={css.productsCounter}>{products?.length || 0}</div>
                                    </div>
                                    <div
                                        onClick={closeModal}
                                        style={uikit.pointer}
                                        className={classNames('circleButton', css.wrapCloseIcon)}
                                    >
                                        {svgSprite('cross', {
                                            width: '14px',
                                            height: '14px'
                                        })}
                                    </div>
                                </div>
                                <div className={css.wrapCartContent}>
                                    {/* {mobile && (
                                        <div className={css.cartCartTitle}>
                                            <div style={{ paddingRight: '5px' }}>
                                                <T textName='store-inBasket' defaultStr='В корзине' page='/store' />
                                            </div>
                                            <div>
                                                {products.length}{' '}
                                                {declOfNum(products.length, [
                                                    <T
                                                        key={'declOfNum_products_1'}
                                                        textName='store-inBasket-product'
                                                        defaultStr='товар'
                                                        page='/store'
                                                    />,
                                                    <T
                                                        key={'declOfNum_products_2'}
                                                        textName='store-inBasket-product2'
                                                        defaultStr='товара'
                                                        page='/store'
                                                    />,
                                                    <T
                                                        key={'declOfNum_products_3'}
                                                        textName='store-inBasket-product3'
                                                        defaultStr='товаров'
                                                        page='/store'
                                                    />
                                                ])}
                                            </div>
                                        </div>
                                    )} */}
                                    <div className={css.cart}>
                                        <Cart products={products} subtype='modal' />
                                    </div>
                                    <div>
                                        <CartFooter
                                            total={cartData?.total_price_for_currency_formatted}
                                            total_marketing={cartData?.total_marketing_price_formatted}
                                            lang={lang}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className={classNames(css.adminWindowContentWrapper)}>
                                <div className={css.cartHeaderTitle}>
                                    <div className={css.wrapArrowBack} onClick={closeModal}>
                                        <Img src={ArrowLeftLong} width={24} height={24} />
                                    </div>
                                    <div className={css.titleBlock}>
                                        <T textName='BasketPageTitle' defaultStr='Корзина' page='/store' />
                                        <div className={css.productsCounter}>{products?.length || 0}</div>
                                    </div>
                                    <div
                                        onClick={closeModal}
                                        style={uikit.pointer}
                                        className={classNames('circleButton', css.wrapCloseIcon)}
                                    >
                                        {svgSprite('cross', {
                                            width: '14px',
                                            height: '14px'
                                        })}
                                    </div>
                                </div>
                                <Plug
                                    classes={{
                                        plugContainer: [css.emptyCart]
                                    }}
                                    plugImg={shop_cart_is_empty}
                                    plugTitle={
                                        <T textName='store-Basket-isEmpty' defaultStr='Ваша корзина пуста' page='/store' />
                                    }
                                    plugDescription={
                                        <T
                                            textName='store-Basket-AddMoreProductIn'
                                            defaultStr='Вы можете это исправить. Добавляйте в корзину товары, которые вам понравились'
                                            page='/store'
                                        />
                                    }
                                    btnGroups={[
                                        [
                                            {
                                                text: (
                                                    <T
                                                        textName='store-Basket-GoToBuying'
                                                        defaultStr='Перейти к покупкам'
                                                        page='/store'
                                                    />
                                                ),
                                                onClick: () => {
                                                    setTimeout(() => closeModal(), 400);
                                                    navigateV2('/store');
                                                }
                                            }
                                        ]
                                    ]}
                                />
                            </div>
                        )}
                    </div>
                </Portal>
            )}
        </div>
    );
};
export default Cartbuttons;
// conttype={showFilerForm ? 'scroll' : ''}
